import { render, staticRenderFns } from "./UsersNumberAndWaterType.vue?vue&type=template&id=0f8fac27&scoped=true"
import script from "./UsersNumberAndWaterType.vue?vue&type=script&lang=js"
export * from "./UsersNumberAndWaterType.vue?vue&type=script&lang=js"
import style0 from "./UsersNumberAndWaterType.vue?vue&type=style&index=0&id=0f8fac27&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8fac27",
  null
  
)

export default component.exports